import React from 'react';
import PropTypes from 'prop-types';
import { Select, Card } from '@ipc/ipc-components';

import { DayPickerInput, FormLabel } from '../../../elements';

import { FREQUENCY_OPTIONS, MONTH_DAYS_OPTIONS, WEEK_DAYS_OPTIONS } from '../constants';

const ScheduledTypeComponent = ({
  values, validations, options, onDateChange, onSelectChange,
}) => {
  const isMonthly = values.frequency && values.frequency.value === 'MONTHLY';
  const isWeekly = values.frequency && values.frequency.value === 'WEEKLY';
  const forPreviousDays = `${isWeekly ? 7 : 14} days`;
  const forPrevious = isMonthly ? 'Calendar Month' : forPreviousDays;

  return (
    <Card>
      <div className="FormRow">
        <FormLabel title="Date Type" required hasError={!validations.dateType}>
          <Select options={options.dateType} value={values.dateType} className="Input SingleSelect" onChange={onSelectChange} name="dateType" />
        </FormLabel>
      </div>
      <div className="FormRow">
        <div className="FormRowInlineFlex">
          <FormLabel title="Frequency" required hasError={!validations.frequency}>
            <Select options={FREQUENCY_OPTIONS} value={values.frequency} className="Input SingleSelect" onChange={onSelectChange} name="frequency" />
          </FormLabel>
          <FormLabel title={`Day Report is Run in ${isMonthly ? 'Month' : 'Week'}`} required hasError={!validations.runDay}>
            <Select options={isMonthly ? MONTH_DAYS_OPTIONS : WEEK_DAYS_OPTIONS} value={values.runDay} className="Input SingleSelect" onChange={onSelectChange} name="runDay" />
          </FormLabel>
        </div>
      </div>
      <div className="FormRow">
        <FormLabel title="Reporting Period from">
          <div className="Input">{values.frequency ? `Previous ${forPrevious}` : ''}</div>
        </FormLabel>
      </div>
      <div className="FormRow">
        <div className="FormRowInlineFlex">
          <FormLabel title="Scheduling Start Date" required forDayPicker hasError={!validations.startDate}>
            <DayPickerInput value={values.startDate} onChange={onDateChange('startDate')} name="startDate" />
          </FormLabel>
          <FormLabel title="Scheduling End Date" required forDayPicker hasError={!validations.endDate}>
            <DayPickerInput value={values.endDate} onChange={onDateChange('endDate')} name="endDate" />
          </FormLabel>
        </div>
      </div>
    </Card>
  );
};

ScheduledTypeComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  options: PropTypes.shape(),
  onDateChange: PropTypes.func,
  onSelectChange: PropTypes.func,
};

export default ScheduledTypeComponent;
